import { yAxisSplitLine } from './echartOptionCommon'
export function RankingMainFunctionsEchartOp ({ v }) {
  // new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
  let option = {
    color: [],
    legend: {
      show: false,
      icon: 'circle',
      data: ['遥控器', '新增激活', '手机APP', '阵列MAC'],
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    grid: {
      left: '0%',
      top: '0%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      data: [
        '联动应用',
        '智慧眼',
        '视频通话',
        '家庭看护',
        '影视',
        '遥控',
        '投屏'
      ],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: yAxisSplitLine
    }],
    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#01C7E5' // 0% 处的颜色
        }, {
          offset: 1, color: '#042CF3' // 100% 处的颜色
        }]
      },
      data: [
        1922,
        2899,
        5029,
        12829,
        28299,
        38292,
        48292
      ],
      barWidth: v.fontSizeRem(1.25),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.1)'
      },
      label: {
        normal: {
          position: 'insideRight',
          show: false,
          textBorderColor: '#333',
          textBorderWidth: 2,
          color: 'rgba(255,255,255,1)'
        }
      }
    }]
  }

  return option
}

export function VideoCallEchartOp ({ v }) {
  let option = {
    color: ['rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '13%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      data: ['日均通话时长'],
      icon: 'bar',
      itemWidth: v.fontSizeRem(1.5),
      itemHeight: v.fontSizeRem(0.25),
      top: 5,
      right: 0,
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      },
      itemStyle: {
        color: 'rgba(0, 114, 255, 1)'
      }
    },
    xAxis: {
      type: 'category',
      data: [
        '02-01',
        '02-02',
        '02-03',
        '02-04',
        '02-05',
        '02-06',
        '02-07',
        '02-08',
        '02-09',
        '02-10',
        '02-11',
        '02-12',
        '02-13',
        '02-14',
        '02-15',
        '02-16',
        '02-17',
        '02-18',
        '02-19',
        '02-20',
        '02-21',
        '02-22',
        '02-23',
        '02-24',
        '02-25',
        '02-26',
        '02-27',
        '02-28'
      ],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      name: '秒',
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine,
      nameTextStyle: {
        color: 'rgba(255, 255, 255, 1)'
      }
    },
    series: [
      {
        name: '日均通话时长',
        data: [130, 137, 114, 117, 124, 121, 136, 116, 144, 127, 132, 138, 135, 134, 126, 138, 135, 123, 132, 132, 139, 144, 127, 133, 157, 123, 142, 124],
        type: 'line',
        smooth: true,
        symbol: 'none'
      }
    ]
  }
  return option
}
export function ProjectionScreenEchartOp ({ v }) {
  let option = {
    color: ['rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '13%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      data: ['投屏次数'],
      icon: 'bar',
      itemWidth: v.fontSizeRem(1.5),
      itemHeight: v.fontSizeRem(0.25),
      top: 5,
      right: 0,
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      },
      itemStyle: {
        color: 'rgba(0, 114, 255, 1)'
      }
    },
    xAxis: {
      type: 'category',
      data: [
        '02-09',
        '02-10',
        '02-11',
        '02-12',
        '02-13',
        '02-14',
        '02-15',
        '02-16',
        '02-17',
        '02-18',
        '02-19',
        '02-20',
        '02-21',
        '02-22',
        '02-23',
        '02-24',
        '02-25',
        '02-26',
        '02-27',
        '02-28',
        '03-01',
        '03-02',
        '03-03',
        '03-04',
        '03-05',
        '03-06',
        '03-07',
        '03-08',
        '03-09',
        '03-10'

      ],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      name: '次',
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine,
      nameTextStyle: {
        color: 'rgba(255, 255, 255, 1)'
      }
    },
    series: [
      {
        name: '投屏次数',
        data: [1, 12, 103, 6, 2, 8, 4, 5, 54, 5, 5, 4, 12, 112, 2, 11, 7, 8, 4, 5, 11, 2, 2, 4, 0, 0, 9, 0, 1, 4],
        type: 'line',
        smooth: true,
        symbol: 'none'
      }
    ]
  }
  return option
}
export function HomeCareEchartOp ({ v }) {
  let option = {
    color: ['rgba(0, 114, 255, 1)'],
    legend: {
      data: ['使用次数'],
      icon: 'bar',
      itemWidth: v.fontSizeRem(1.5),
      itemHeight: v.fontSizeRem(0.25),
      top: 5,
      right: 0,
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      },
      itemStyle: {
        color: 'rgba(0, 114, 255, 1)'
      }
    },
    grid: {
      left: '5%',
      top: '13%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [
        '02-01',
        '02-02',
        '02-03',
        '02-04',
        '02-05',
        '02-06',
        '02-07',
        '02-08',
        '02-09',
        '02-10',
        '02-11',
        '02-12',
        '02-13',
        '02-14',
        '02-15',
        '02-16',
        '02-17',
        '02-18',
        '02-19',
        '02-20',
        '02-21',
        '02-22',
        '02-23',
        '02-24',
        '02-25',
        '02-26',
        '02-27',
        '02-28'
      ],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      name: '次',
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine,
      nameTextStyle: {
        color: 'rgba(255, 255, 255, 1)'
      }
    },
    series: [
      {
        name: '使用次数',
        data: [
          11520,
          19691,
          21020,
          14604,
          12934,
          13010,
          13928,
          14038,
          21149,
          22191,
          17653,
          17279,
          19827,
          20696,
          20839,
          23062,
          23167,
          23785,
          23183,
          22816,
          22587,
          22689,
          22050,
          19967,
          19538,
          18868,
          19505,
          25874
        ],
        type: 'line',
        smooth: true,
        symbol: 'none'
      }
    ]
  }
  return option
}
